module.exports = __webpack_public_path__ + "img/hat-witch.37c41685.svg";